import { CircularProgress, Box } from '@mui/material';

export const PageLoading = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress
        sx={{
          position: 'absolute',
          top: 'calc(50% - 50px)',
          left: 'calc(50% - 50px)',
        }}
        size={100}
      />
    </Box>
  );
};
